(() => {
  const mobileBreakpoint = window.matchMedia('(max-width: 749px)');
  const mobileCartFab = document.querySelector('.mobile-cart-fab[data-mobile-cart-toggle]');

  const FAB_STORAGE_KEY = 'hohomakes-mobile-cart-fab-position-v4';
  const FAB_EDGE_GAP = 16;
  const FAB_TOP_CLEARANCE = 8;
  const FAB_DRAG_THRESHOLD = 8;
  const FAB_BOUNCE_DURATION = 420;

  if (!mobileCartFab) return;

  function isMobile() {
    return mobileBreakpoint.matches;
  }

  function isCartPage() {
    return document.body.classList.contains('template-cart') || Boolean(document.querySelector('.cart-page'));
  }

  function getHeaderHeight() {
    const header = document.querySelector('[data-header]');
    const cssHeight =
      parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;

    if (!header) return cssHeight;

    const rect = header.getBoundingClientRect();
    return Math.max(cssHeight, rect.height || 0, rect.bottom || 0);
  }

  function getMinTop() {
    return Math.max(FAB_EDGE_GAP, Math.round(getHeaderHeight() + FAB_TOP_CLEARANCE));
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function getFabBounds(element) {
    const rect = element.getBoundingClientRect();
    const minTop = getMinTop();

    return {
      rect,
      minTop,
      maxLeft: Math.max(FAB_EDGE_GAP, window.innerWidth - rect.width - FAB_EDGE_GAP),
      maxTop: Math.max(minTop, window.innerHeight - rect.height - FAB_EDGE_GAP)
    };
  }

  function clearFabPosition(element) {
    element.style.left = '';
    element.style.right = '';
    element.style.top = '';
    element.style.bottom = '';
  }

  function readFabPosition() {
    try {
      return JSON.parse(window.localStorage.getItem(FAB_STORAGE_KEY) || 'null');
    } catch (error) {
      return null;
    }
  }

  function saveFabPosition(position) {
    try {
      window.localStorage.setItem(FAB_STORAGE_KEY, JSON.stringify(position));
    } catch (error) {
      // ignore storage failures
    }
  }

  function triggerFabBounce(element, side) {
    if (!element) return;

    let bounceX = '0px';
    let bounceY = '0px';

    if (side === 'left') bounceX = '7px';
    if (side === 'right') bounceX = '-7px';
    if (side === 'top') bounceY = '7px';
    if (side === 'bottom') bounceY = '-7px';

    element.style.setProperty('--fab-bounce-x', bounceX);
    element.style.setProperty('--fab-bounce-y', bounceY);

    element.classList.remove('is-snapping');
    void element.offsetWidth;
    element.classList.add('is-snapping');

    window.setTimeout(() => {
      element.classList.remove('is-snapping');
    }, FAB_BOUNCE_DURATION);
  }

  function triggerFabSplash(element, side) {
    if (!element || !side) return;

    const existing = element.querySelector('.mobile-cart-fab__splash');
    if (existing) {
      existing.remove();
    }

    const splash = document.createElement('span');
    splash.className = `mobile-cart-fab__splash mobile-cart-fab__splash--${side}`;

    for (let index = 0; index < 3; index += 1) {
      const dot = document.createElement('span');
      dot.className = 'mobile-cart-fab__splash-dot';
      splash.appendChild(dot);
    }

    element.appendChild(splash);

    window.setTimeout(() => {
      splash.remove();
    }, FAB_BOUNCE_DURATION + 80);
  }

  function applyFabPosition(element, position) {
    if (!element || !position) return;

    const { rect, minTop, maxLeft, maxTop } = getFabBounds(element);
    const nextX = clamp(Number(position.x) || FAB_EDGE_GAP, FAB_EDGE_GAP, maxLeft);
    const nextY = clamp(Number(position.y) || minTop, minTop, maxTop);

    clearFabPosition(element);

    switch (position.side) {
      case 'left':
        element.style.left = `${FAB_EDGE_GAP}px`;
        element.style.top = `${nextY}px`;
        break;
      case 'right':
        element.style.right = `${FAB_EDGE_GAP}px`;
        element.style.top = `${nextY}px`;
        break;
      case 'top':
        element.style.top = `${minTop}px`;
        element.style.left = `${nextX}px`;
        break;
      case 'bottom':
      default:
        element.style.bottom = `calc(${FAB_EDGE_GAP}px + env(safe-area-inset-bottom))`;
        element.style.left = `${nextX}px`;
        break;
    }

    if (rect.width === 0 || rect.height === 0) {
      element.style.right = `${FAB_EDGE_GAP}px`;
      element.style.bottom = `calc(${FAB_EDGE_GAP}px + env(safe-area-inset-bottom))`;
      element.style.left = '';
      element.style.top = '';
    }
  }

  function getClosestEdge(rect, minTop) {
    const distances = {
      left: rect.left,
      right: window.innerWidth - rect.right,
      top: Math.max(0, rect.top - minTop),
      bottom: Math.max(0, window.innerHeight - rect.bottom - FAB_EDGE_GAP)
    };

    return Object.entries(distances).sort((a, b) => a[1] - b[1])[0][0];
  }

  function snapFabToEdge(element) {
    if (!element) return;

    const { rect, minTop, maxLeft, maxTop } = getFabBounds(element);
    const side = getClosestEdge(rect, minTop);

    const position = {
      side,
      x: clamp(rect.left, FAB_EDGE_GAP, maxLeft),
      y: clamp(rect.top, minTop, maxTop)
    };

    applyFabPosition(element, position);
    saveFabPosition(position);
    triggerFabBounce(element, side);
    triggerFabSplash(element, side);
  }

  function applyDefaultFabPosition(element) {
    if (!element) return;

    const saved = readFabPosition();
    if (saved) {
      applyFabPosition(element, saved);
      return;
    }

    clearFabPosition(element);
    element.style.right = `${FAB_EDGE_GAP}px`;
    element.style.bottom = `calc(${FAB_EDGE_GAP}px + env(safe-area-inset-bottom))`;
  }

  function resetFabState() {
    clearFabPosition(mobileCartFab);
    mobileCartFab.classList.remove('is-dragging');
    mobileCartFab.classList.remove('is-snapping');
    mobileCartFab.dataset.suppressClick = 'false';

    const splash = mobileCartFab.querySelector('.mobile-cart-fab__splash');
    if (splash) {
      splash.remove();
    }
  }

  function setupFloatingCartDrag(element) {
    if (!element || element.dataset.dragReady === 'true') return;
    element.dataset.dragReady = 'true';

    let pointerId = null;
    let startX = 0;
    let startY = 0;
    let startLeft = 0;
    let startTop = 0;
    let didDrag = false;

    const onPointerMove = (event) => {
      if (event.pointerId !== pointerId) return;

      const dx = event.clientX - startX;
      const dy = event.clientY - startY;
      const movedEnough = Math.abs(dx) > FAB_DRAG_THRESHOLD || Math.abs(dy) > FAB_DRAG_THRESHOLD;

      if (!didDrag && movedEnough) {
        didDrag = true;
        element.classList.add('is-dragging');
      }

      if (!didDrag) return;

      event.preventDefault();

      const { maxLeft, minTop, maxTop } = getFabBounds(element);
      const nextLeft = clamp(startLeft + dx, FAB_EDGE_GAP, maxLeft);
      const nextTop = clamp(startTop + dy, minTop, maxTop);

      element.style.left = `${nextLeft}px`;
      element.style.top = `${nextTop}px`;
      element.style.right = 'auto';
      element.style.bottom = 'auto';
    };

    const endDrag = (event) => {
      if (event.pointerId !== pointerId) return;

      element.releasePointerCapture?.(pointerId);
      pointerId = null;

      window.removeEventListener('pointermove', onPointerMove);
      window.removeEventListener('pointerup', endDrag);
      window.removeEventListener('pointercancel', endDrag);

      element.classList.remove('is-dragging');

      if (!didDrag) return;

      element.dataset.suppressClick = 'true';
      snapFabToEdge(element);

      window.setTimeout(() => {
        element.dataset.suppressClick = 'false';
      }, 80);

      didDrag = false;
    };

    element.addEventListener('pointerdown', (event) => {
      if (!isMobile() || isCartPage()) return;
      if (document.body.classList.contains('cart-drawer-open')) return;
      if (event.button !== 0 && event.pointerType !== 'touch') return;

      const rect = element.getBoundingClientRect();

      pointerId = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
      startLeft = rect.left;
      startTop = rect.top;
      didDrag = false;
      element.dataset.suppressClick = 'false';

      element.setPointerCapture?.(pointerId);

      window.addEventListener('pointermove', onPointerMove, { passive: false });
      window.addEventListener('pointerup', endDrag);
      window.addEventListener('pointercancel', endDrag);
    });

    element.addEventListener(
      'click',
      (event) => {
        if (element.dataset.suppressClick === 'true') {
          event.preventDefault();
          event.stopPropagation();
          element.dataset.suppressClick = 'false';
        }
      },
      true
    );
  }

  function refreshFloatingCart() {
    if (!isMobile() || isCartPage()) {
      resetFabState();
      return;
    }

    applyDefaultFabPosition(mobileCartFab);
    setupFloatingCartDrag(mobileCartFab);
  }

  document.addEventListener('cart:drawer:opened', refreshFloatingCart);
  document.addEventListener('cart:drawer:closed', refreshFloatingCart);

  mobileBreakpoint.addEventListener('change', refreshFloatingCart);
  window.addEventListener('resize', refreshFloatingCart);
  window.addEventListener('orientationchange', refreshFloatingCart);
  document.addEventListener('DOMContentLoaded', refreshFloatingCart);

  window.HohoMobileCartFab = {
    refresh: refreshFloatingCart
  };

  refreshFloatingCart();
})();